<template>
  <div class="page-loading-container">
    <div class="icon">
      <!-- <img src="@/assets/img/inmoat.gif" class="mx-auto" alt="InMoat loading symbol" /> -->
      <i class="fas fa-spinner fa-spin" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageLoadingMessage',
};
</script>

<style scope>
.page-loading-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.page-loading-container i {
  color: rgb(16, 185, 129);
  font-size: 8rem;
  margin-bottom: 2rem;
}
</style>
